import * as categories from '../categories';
import { STRICTLY_NECESSARY, FUNCTIONAL, TARGETING, PERFORMANCE } from '../constants';
import { arrayUnique } from 'utils/utils';

const dict = {
	consent: STRICTLY_NECESSARY,
	c1: STRICTLY_NECESSARY,
	c2: PERFORMANCE,
	c3: FUNCTIONAL,
	c4: TARGETING,
};

export const set = (ids) => {
	const list = Array.isArray(ids) ? ids : ids.split(',');
	const newCats = arrayUnique(list.map(id => dict[id]).filter(a => !!a));
	categories.set(newCats);
};
